(() => {
  const footer = document.getElementById('main-cart-footer');
  if (!footer) return;
  const container = footer.querySelector('.container');
  const actions = container.querySelector('.cart-template__button');
  const checkout = container.querySelector('.cart-template__bottom');
  const errors = container.querySelector('#cart-errors');
  if (!actions || !checkout || !errors) return;
  const mobile = window.matchMedia('(max-width: 767px)');
  const arrange = () => container.insertBefore(actions, mobile.matches ? errors : checkout);
  arrange();
  if (mobile.addEventListener) mobile.addEventListener('change', arrange);
  else mobile.addListener(arrange);
})();
